<template>
  <main>
    <FormRequest />
  </main>
</template>

<script>
import FormRequest from '~/components/FormRequest'
export default {
  components: {
    FormRequest
  },

}
</script>

<style></style>



// WEBPACK FOOTER //
// pages/request-form.vue